import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import 'isotope-layout/dist/isotope.pkgd.js';
import 'lightgallery/dist/js/lightgallery-all';
import 'imagesloaded/imagesloaded.pkgd.js';
import 'jquery-match-height/dist/jquery.matchHeight.js';

import 'select2/dist/js/select2.js';

import noUiSlider from 'nouislider';


fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	function myAddParameterAndReturn(url, paramName, paramValue)
	{
	    if (url.indexOf(paramName + "=") >= 0)
	    {
	        var prefix = url.substring(0, url.indexOf(paramName));
	        var suffix = url.substring(url.indexOf(paramName));
	        suffix = suffix.substring(suffix.indexOf("=") + 1);
	        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
	        url = prefix + paramName + "=" + paramValue + suffix;
	    }
	    else
	    {
	    if (url.indexOf("?") < 0)
	        url += "?" + paramName + "=" + paramValue;
	    else
	        url += "&" + paramName + "=" + paramValue;
	    }
	    return url;
	}

	var geoMarkers = [];
	var googleMapMarkers = [];

	function is_touch_device() {
	  return 'ontouchstart' in window        // works on most browsers 
	      || navigator.maxTouchPoints;       // works on IE10/11 and Surface
	};

	function requestMarkers(map, url, oms){
	    deleteMarkers();
	    $.ajax({
	      dataType: "json",
	      url: url,
	    }).done(function(json) {
	      $.each(json, function(index, elem){
	       // console.log(elem);
	        geoMarkers.push({
	             "type": "Feature",
	             "geometry": {
	                 "type": "Point",
	                 "coordinates": [
	                     elem.address.lng,
	                     elem.address.lat
	                 ]
	             },
	             "properties": {
	                 "postid" : elem.post.ID,
	                 "link": elem.permalink,
	                 "marker": elem.markerIcon
	             }
	         });
	      });
	      oms.removeAllMarkers();
	      setMarkers(map, geoMarkers, oms);
	    })
	}

	
	function setMarkers(map, geoMarkers, oms){
	    var geojson =
	    {
	        "type": "FeatureCollection",
	        "features": geoMarkers
	        
	    };

	    
	    //console.log(geojson);
	    if (geojson.features.length >= 1) {
	        var bounds = new google.maps.LatLngBounds();	        
	        geojson.features.forEach(function(feature) {
	          if (feature.geometry.coordinates[1] && feature.geometry.coordinates[0]) {
	            var icon = new google.maps.MarkerImage(
	                        feature.properties.marker,
	                        new google.maps.Size(28,39),
	                        null,
	                        null,
	                        new google.maps.Size(28,39)
	                    );
	            
	            var markerpos = new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
	            var marker = new google.maps.Marker({
	              position: markerpos,
	              map: map,
	              title: '',
	              animation: google.maps.Animation.DROP,
	              url: feature.properties.link,
	              icon: icon
	            });

	            oms.addMarker(marker);
	            //googleMapMarkers.push(marker);
	          //  console.log(feature)
	            google.maps.event.addListener(marker, 'spider_click', function() {
	                window.open(this.url);
	            });
	            bounds.extend(markerpos);
	            }
	        });
	        google.maps.event.trigger(map, "resize");
	        $('.loadingOverlay').hide();
	        if (geoMarkers.length > 1) {
	          map.fitBounds(bounds);
	          setTimeout(function(){
	          	map.setZoom(map.getZoom());
	          }, 100)
	          
	        } else {
	          map.fitBounds(bounds);
	          map.setZoom(12);
	        }
	    };
	}

	function deleteMarkers() {
	    for (var i = 0; i < googleMapMarkers.length; i++) {
	        googleMapMarkers[i].setMap(null);
	    }
	    googleMapMarkers = [];
	    geoMarkers  = [];
	}

	$('.match-height').matchHeight();

	if ($('.teamrow').length) {
		var $grid = $('.teamrow').isotope({
			itemSelector: '.grid-item'
		});

		$grid.imagesLoaded().progress( function() {
			$grid.isotope({
				itemSelector: '.grid-item'
			});
		});

		$grid.on('arrangeComplete', function (event, filteredItems) {
			$('.match-height:visible').matchHeight();
			$grid.isotope('layout');
		});
	}

	// var maxHeight = 0;

	// $('.grid-item').each(function(){
	// 	var thisH = $(this).height();
	// 	if (thisH > maxHeight) { maxHeight = thisH; }
	// });

	// $('.grid-item').height(maxHeight);
	// var filterValue = this.value;

	if ($('.filters-select').length) {
		$('.filters-select').select2();

		$('.filters-select').on( 'change', function() {
			// get filter value from option value
		
			var maxHeight = 0;

			$('.grid-item').each(function(){
				var thisH = $(this).height();
				if (thisH > maxHeight) { maxHeight = thisH; }
			});

			$('.grid-item').height(maxHeight);
			var filterValue = this.value;
			// console.log(filterValue);
			// use filterFn if matches value
			$grid.isotope({ filter: filterValue });
		
		});
	}

	$('.gallery').lightGallery({
		selector: '.gallery-item a'
	});

	$('.casawp-carousel').lightGallery({
		selector: '.property-image-gallery',
		download: false,
		thumbnail: false
	});


	$('.casadistance__menu__button').on('click', function(){
		$('html, body').animate({
			scrollTop: $('.casadistance__menu').offset().top
		}, 500);
	});

	$('.navbar-toggler').on('click', function(){
		if ($(this).hasClass('active-nav')) {
			$(this).removeClass('active-nav');
			$('.navbarOuter').removeClass('nav-bg');
		} else {
			$(this).addClass('active-nav');
			$('.navbarOuter').addClass('nav-bg');
		}
	});

	$('.navbar-collapse').on('shown.bs.collapse', function(){
		$('#footer').hide();
		$('#content').hide();
		$('.sliderOuter').hide();

	});

	$('.navbar-collapse').on('show.bs.collapse', function(){
		$('html, body').animate({
			scrollTop: $('html, body').offset().top
		}, 500);
		$('html').addClass('navBackground');
	});

	$('.navbar-collapse').on('hidden.bs.collapse', function(){
	});

	$('.navbar-collapse').on('hide.bs.collapse', function(){
		$('#footer').show();
		$('#content').show();
		$('.sliderOuter').show();
		$('html').removeClass('navBackground');
	});

	$('#navigation .menu-item-has-children > a').on('click', function(e){
		e.preventDefault();
		$(this).trigger('click');
		return false;
	});

	$('.wpml-ls > ul > li > a').on('click', function(e){
		e.preventDefault();
		$(this).trigger('click');
		return false;
	});

	window.addEventListener( 'load', function() {
		$('.chosen-single').append('<i class="fal fa-angle-down"></i>');
	});

	$('.main-menu .menu-item-has-children > a, .wpml-ls-item a:first').append('<i class="fal fa-angle-down"></i>');

	$('<i class="fal fa-angle-down"></i>').insertAfter('.form-control-singleselect').hide();

	if (is_touch_device()) {
		$('.form-control-singleselect').nextAll().show();
	}

	$('.form-group select').parent().append('<i class="fal fa-angle-down"></i>');


	var maxHeight = 0;

	if ($('.casawp-shortcode-properties').length) {

		$('.casawp-shortcode-properties .casawp-property').each(function(){
			var thisThumb = $(this).find('.thumbOuter');
			var thisText = $(this).find('.casawp-text');
			var thisH = thisThumb.outerHeight() + thisText.outerHeight();
			if (thisH > maxHeight) { maxHeight = thisH; }
		});

		var shortFlickity = new Flickity('.casawp-shortcode-properties', {
			cellAlign: 'left',
			contain: true,
			imagesLoaded: true,
			pageDots: false,
			prevNextButtons: true,
			draggable: true,
			setGallerySize: true,
			autoPlay: 5000,
			arrowShape: 'M94.7762777,45.7462648 L96.8509582,45.7462648 L96.8509582,47.5917818 L99.8321434,50.2436733 L96.8509582,52.9263562 L96.8509582,54.080265 L95.5686539,54.080265 L69.2055383,77.8036752 L69.2055383,54.080265 L0,54.080265 L0,45.7462648 L69.2055383,45.7462648 L69.2055383,23 L94.7762777,45.7462648 Z'
		});
		if (shortFlickity.slides.length <= 2) {
			$('.flickity-page-dots').hide();
		}

		$('.casawp-shortcode-properties .colProperty').css('height', maxHeight);
		shortFlickity.resize();


		$(window).on('resize', function(){
			maxHeight = 0;
			$('.casawp-shortcode-properties .casawp-property').each(function(){
				var thisThumb = $(this).find('.thumbOuter');
				var thisText = $(this).find('.casawp-text');
				var thisH = thisThumb.outerHeight() + thisText.outerHeight();
				if (thisH > maxHeight) { maxHeight = thisH; }
			});
			$('.casawp-shortcode-properties .colProperty').css('height', maxHeight);
			//shortFlickity.resize();
		});
	}

	if ($('.slider').length) {
		var slider = new Flickity('.slider', {
			cellAlign: 'left',
			wrapAround: true,
			imagesLoaded: true,
			pageDots: false,
			prevNextButtons: false,
			draggable: false,
			autoPlay: 4000,
			pauseAutoPlayOnHover: false
		});

		//slider.resize();

		// slider.on('staticClick', function(event, pointer, cellElement, cellIndex) {
		//     slider.playPlayer();
		// });

	}

	if ($('.casawp-main-flickity').length) {
		var immoSlider = new Flickity('.casawp-main-flickity', {
			cellAlign: 'center',
			autoPlay: 7000,
			draggable: true,
			wrapAround: true,
			pageDots: false,
			imagesLoaded: true,
			prevNextButtons: true,
			setGallerySize: true,
			arrowShape: 'M94.7762777,45.7462648 L96.8509582,45.7462648 L96.8509582,47.5917818 L99.8321434,50.2436733 L96.8509582,52.9263562 L96.8509582,54.080265 L95.5686539,54.080265 L69.2055383,77.8036752 L69.2055383,54.080265 L0,54.080265 L0,45.7462648 L69.2055383,45.7462648 L69.2055383,23 L94.7762777,45.7462648 Z'
		});

		immoSlider.resize();

	}

	$('.casawp-main-flickity').lightGallery({
		selector: '.property-image-gallery',
		download: false,
		thumbnail: false
	});

	$('.flickity-prev-next-button').wrapAll('<div class="container"></div>');


	if ($('.grid').length) {
		var $grid = $('.grid').isotope({
			itemSelector: '.grid-item'
		});

		$grid.imagesLoaded().progress( function() {
			$grid.isotope({
				itemSelector: '.grid-item'
			});
		});
	}

	$('.toggle-map').on('click', function(e){
		e.preventDefault();
		if ($('.map-wrap').hasClass('map-wrap--hidden')) {
			$('.map-wrap').removeClass('map-wrap--hidden');
			$(this).find('.show-map').addClass('d-none');
			$(this).find('.hide-map').removeClass('d-none');
			if ($('#casawp-map').length) {
				initializeMapBoxCasaWP();
				disable_scroll();
				$('html, body').stop().animate({
					scrollTop: $('#casawp-map').offset().top - $('#header').outerHeight()
				}, 700, function () {
					enable_scroll();
				});
			};
		} else {
			$('.map-wrap').addClass('map-wrap--hidden');
			$(this).find('.show-map').removeClass('d-none');
			$(this).find('.hide-map').addClass('d-none');
			disable_scroll();
			$('html, body').stop().animate({
				scrollTop: $('.map-wrap').offset().top - $('#header').outerHeight()
			}, 700, function () {
				enable_scroll();
			});
		}
		return false;
	});

	function initializeMapBoxCasaWP() {

		var style = [
			{
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#f5f5f5"
				}
			]
			},
			{
			"elementType": "labels.icon",
			"stylers": [
				{
				"visibility": "off"
				}
			]
			},
			{
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#616161"
				}
			]
			},
			{
			"elementType": "labels.text.stroke",
			"stylers": [
				{
				"color": "#f5f5f5"
				}
			]
			},
			{
			"featureType": "administrative.land_parcel",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#bdbdbd"
				}
			]
			},
			{
			"featureType": "poi",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#eeeeee"
				}
			]
			},
			{
			"featureType": "poi",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#757575"
				}
			]
			},
			{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#e5e5e5"
				}
			]
			},
			{
			"featureType": "poi.park",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#9e9e9e"
				}
			]
			},
			{
			"featureType": "road",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#ffffff"
				}
			]
			},
			{
			"featureType": "road.arterial",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#757575"
				}
			]
			},
			{
			"featureType": "road.highway",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#dadada"
				}
			]
			},
			{
			"featureType": "road.highway",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#616161"
				}
			]
			},
			{
			"featureType": "road.local",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#9e9e9e"
				}
			]
			},
			{
			"featureType": "transit.line",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#e5e5e5"
				}
			]
			},
			{
			"featureType": "transit.station",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#eeeeee"
				}
			]
			},
			{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#c9c9c9"
				}
			]
			},
			{
			"featureType": "water",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#9e9e9e"
				}
			]
			}
		]

		var mapOptions = {
			center: {lat: 47.247913, lng: 8.674145},
			zoom: 14,
			disableDefaultUI: false,
			zoomControl: true,
			mapTypeControlOptions: {
					mapTypeIds: ['roadmap', 'hybrid']
				},
			styles: style
		};
		var map = new google.maps.Map(document.getElementById('casawp-map'), mapOptions);

		var oms = new OverlappingMarkerSpiderfier(map, {
			markersWontMove: false,
			markersWontHide: false,
			basicFormatEvents: false
		});

		// set gray style
		map.mapTypes.set('gray_map',
			new google.maps.StyledMapType([{stylers: [{saturation: -90}]}],
				{name: "Karte"}));
		map.setMapTypeId('gray_map');

		if ($('.casawp-property').length > 0) {
			$('.loadingOverlay').removeAttr('style');
		}
		if ($('.casawp-archive').hasClass('flowRef')) {
			requestMarkers(map, '/immobilien/?filter_meta_key=custom_option_Referenzobjekt&salestypes=&utilities=&categories=&locations=&rooms_from=&rooms_to=&features=&ajax=1&posts_per_page=100&json=1', oms);
		} else if (!$('.casawp-archive').hasClass('refArchive')) {
			var $form = $('.casawp-filterform');
			var filteredParams = $form.serialize();
			var url = $form.prop('action');
			url = url.replace(window.location.protocol + "//" + window.location.host, '');

			var filteredUrl = myAddParameterAndReturn(url + '?' + filteredParams, 'ajax', '1');
			filteredUrl = filteredUrl + '&posts_per_page=999&json=1';
			//console.log(filteredUrl);
			requestMarkers(map, filteredUrl, oms);

			$('.casawp-filterform').on( "casawp-ajaxfilter:filter-submit", function(event, url, filteredUrl){
				requestMarkers(map, filteredUrl+"&ajax=1&posts_per_page=999&json=1", oms);
			});
		} else {
			var filteredUrl = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname + window.location.search;
			requestMarkers(map, filteredUrl+"&ajax=1&posts_per_page=999&json=1", oms);
		}
	}


	$('.casawp-ajax-archive-list').on( "casawp-ajaxfilter:after-list-reload", function(event, url, filteredUrl){
		setTimeout(function(){
		$('.chosen-single').append('<i class="fal fa-angle-down"></i>');
		}, 500);
		var width = $(window).width(); 
		if (width <= 768) {
			$('html, body').animate({
			scrollTop: $('.contentWrap').offset().top
			}, 1000);
		}
	
	});

	function initializeMap($mapwraper) {
		if ($('.marker').length) {
			var markerIcon = $('.marker').data('marker');
		}
		var location = new google.maps.LatLng($mapwraper.data('lat'),$mapwraper.data('lng'));
		var mapOptions = {
			zoom: parseInt(window.casawpOptionParams.google_maps_zoomlevel),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: location,
			mapTypeControlOptions: {
			mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'gray_map']
			}
		};
		$mapwraper.show();
		var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

		var marker = new google.maps.Marker({
			map: map,
			position: location,
			icon: new google.maps.MarkerImage(
					markerIcon,
					new google.maps.Size(28,39),
					null,
					null,
					new google.maps.Size(28,39)
				)
		});
		map.mapTypes.set('gray_map',
			new google.maps.StyledMapType([{stylers: [{saturation: -90}]}],
				{name: "Gray Map"}));
		map.setMapTypeId('gray_map');
	}

	if ($('.casawp-map').length && google) {
		$('.casawp-map').each(function(){
			var $mapwraper = $(this);
			if ($mapwraper.data('lat') && $mapwraper.data('lng')) {
				//var map;
				if ($('#casawp-mapShowBtn').length) {
					$('#casawp-mapShowBtn').on('click', function() {
						//console.log("click2");
						if ($('#casawp-mapShowBtn').length) {
							$('#casawp-mapShowBtn').css('display', 'none');
						}
						if ($('.casawp-map__placeholder').length) {
							$('.casawp-map__placeholder').css('display', 'none');
						}
						$('.casawp-map').css('display', 'block');
						initializeMap($mapwraper);
					});
				} else {
					initializeMap($mapwraper);
				}
			}
		});
	}
//      console.log("testtt");
//      const $salestypes = $('.casawp-filterform-wrap').find("select[name=salestypes]");
		// console.log("test" + $salestypes);
		// $salestypes.replaceWith('<input type="button" name="salestypes" value="kaufen" /><input type="button" name="salestypes" value="mieten" />');

	rangeDropdownsToSlider();
	$('.casawp-filterform').on( "casawp-filterform:after-filter-reload", function(event, url, filteredUrl){
		rangeDropdownsToSlider();
	});

	function rangeDropdownsToSlider(){
		if($('.casawp-filterform-pricecount-2')){
			$('.casawp-filterform-pricecount-2').each(function(idx, priceWrapperElem){
				const $priceWrapperElem = $(priceWrapperElem);
				const $fromElem = $priceWrapperElem.find("select[name=price_from]");
				const $toElem = $priceWrapperElem.find("select[name=price_to]");
				if ($fromElem.length && $toElem.length) {
					let fromVal = $fromElem.find("option:first-child").val();
					if (!fromVal) {
						//the first item ist often a mask
						fromVal = $fromElem.find("option:nth-child(2)").val();
					}
					const toVal = $toElem.find("option:last-child").val();
					if (fromVal && toVal) {
						$fromElem.replaceWith('<input type="number" name="price_from" value="'+$fromElem.val()+'" />');
						$toElem.replaceWith('<input type="number" name="price_to" value="'+$toElem.val()+'" />');

						const values = $fromElem.find('option').map(function() { return ($(this).val() ? parseInt($(this).val()) : 0); }).get();
						let range = {};
						values.forEach((value, idx) => {
							if (idx === 0) {
								range.min = value;
							} else if((idx+1) === values.length){
								range.max = value;
							} else {
								range[(idx*(100/values.length))+"%"] = value;
							}
						});
						//console.log(range);

						const $rFromElem = $priceWrapperElem.find("input[name=price_from]");
						const $rToElem = $priceWrapperElem.find("input[name=price_to]");

						$priceWrapperElem.find('.casawp-filterform-duo-item label, .casawp-filterform-duo-item div, .casawp-filterform-duo-item input').hide();
						$priceWrapperElem.find('.casawp-filterform-duo-label').show();

						const $rangeSliderControl = $('<div class="form-control form-control-slider"><div class="noUi-placeholder" /></div>');
						$priceWrapperElem.append($rangeSliderControl);

						const sliderElem = $rangeSliderControl.find('.noUi-placeholder')[0];


						noUiSlider.create(sliderElem, {
							start: [
								(parseInt($fromElem.val()) ? parseInt($fromElem.val()) : 0),
								(parseInt($toElem.val()) ? parseInt($toElem.val()) : toVal)
							],
							connect: true,
							snap: true,
							range: range,

							format: {
								to: function ( value ) {
								return Math.round(value);
								},
								from: function ( value ) {
									return Math.round(value);
								}
							}

						});

						var priceSliderValues = [
							document.getElementById('price-slider-lower-value'),
							document.getElementById('price-slider-upper-value')
						];

						priceSliderValues[0].innerHTML = $fromElem.val();
						priceSliderValues[1].innerHTML = $toElem.val();

						sliderElem.noUiSlider.on('update', function( values, handle ) {
							priceSliderValues[handle].innerHTML = 'CHF ' + values[handle];
						});

						sliderElem.noUiSlider.on('change', ( values, handle ) => {
							var value = values[handle];

							if ( handle === 0 ) {
								$rFromElem.val(Math.round(parseInt(value)));
							} else {
								$rToElem.val(Math.round(parseInt(value)));
							}

							$('.casawp-filterform').trigger('change');
						});
					}
				}
			})
		}


		if($('.casawp-filterform-roomscount-2')){
			$('.casawp-filterform-roomscount-2').each(function(idx, roomsWrapperElem){
				const $roomsWrapperElem = $(roomsWrapperElem);
				const $fromElem = $roomsWrapperElem.find("select[name=rooms_from]");
				const $toElem = $roomsWrapperElem.find("select[name=rooms_to]");
				if ($fromElem.length && $toElem.length) {
					let fromVal = $fromElem.find("option:first-child").val();
					if (!fromVal) {
						//the first item ist often a mask
						fromVal = $fromElem.find("option:nth-child(2)").val();
					}
					const toVal = $toElem.find("option:last-child").val();
					if (fromVal && toVal) {
						$fromElem.replaceWith('<input type="number" name="rooms_from" value="'+$fromElem.val()+'" />');
						$toElem.replaceWith('<input type="number" name="rooms_to" value="'+$toElem.val()+'" />');

						const values = $fromElem.find('option').map(function() { return ($(this).val() ? parseInt($(this).val()) : 0); }).get();
						let range = {};
						values.forEach((value, idx) => {
							if (idx === 0) {
								range.min = value;
							} else if((idx+1) === values.length){
								range.max = value;
							} else {
								range[(idx*(100/values.length))+"%"] = value;
							}
						});

						const $rFromElem = $roomsWrapperElem.find("input[name=rooms_from]");
						const $rToElem = $roomsWrapperElem.find("input[name=rooms_to]");

						$roomsWrapperElem.find('.casawp-filterform-duo-item label, .casawp-filterform-duo-item div, .casawp-filterform-duo-item input').hide();
						$roomsWrapperElem.find('.casawp-filterform-duo-label').show();

						const $rangeSliderControl = $('<div class="form-control form-control-slider"><div class="noUi-placeholder" /></div>');
						$roomsWrapperElem.append($rangeSliderControl);

						const sliderElem = $rangeSliderControl.find('.noUi-placeholder')[0];


						noUiSlider.create(sliderElem, {
							start: [
								(parseInt($fromElem.val()) ? parseInt($fromElem.val()) : 0),
								(parseInt($toElem.val()) ? parseInt($toElem.val()) : toVal)
							],
							connect: true,
							snap: true,
							range: range,
							format: {
								to: function ( value ) {
								return Math.round(value);
								},
								from: function ( value ) {
									return Math.round(value);
								}
							}

						});

						var roomsSliderValues = [
							document.getElementById('rooms-slider-lower-value'),
							document.getElementById('rooms-slider-upper-value')
						];

						roomsSliderValues[0].innerHTML = $fromElem.val();
						roomsSliderValues[1].innerHTML = $toElem.val();

						sliderElem.noUiSlider.on('update', function( values, handle ) {
							roomsSliderValues[handle].innerHTML = values[handle];
						});

						sliderElem.noUiSlider.on('change', ( values, handle ) => {
							var value = values[handle];

							if ( handle === 0 ) {
								$rFromElem.val(Math.round(parseInt(value)));
							} else {
								$rToElem.val(Math.round(parseInt(value)));
							}

							$('.casawp-filterform').trigger('change');
						});
					}
				}
			})
		}
	}



	//arrow jumpers
	$('.m-videobanner__jumparrow, .m-imagebanner__jumparrow, .m-slidebanner__jumparrow').on('click', function(event){
		var $root = $('html, body');
		var $elem = $(this);
		$root.animate({
			scrollTop: $elem.offset().top
		}, 1000);
	});

	// Akkordeon
	if ($('.panel__content.show').length) {
		var contentHeight = $(this).find('.panel__content__inner').outerHeight() + 20;
		$('.panel__content.show').css({'height': contentHeight, 'padding-top': '20px'});
	}

	$(window).on('resize', function(){
		var contentHeight = $(this).find('.panel__content__inner').outerHeight() + 20;
		$('.panel__content.show').css({'height': contentHeight, 'padding-top': '20px'});
	});

	$('.panel a').on('click', function(e){
		e.preventDefault();
		if ($(this).hasClass('collapsed')) {
			$('.panel__header a').addClass('collapsed');
			$(this).removeClass('collapsed');
			$(".panel__content").not($(this).parent().next()).removeClass('show');
			$(this).parent().next().addClass('show');
			$('.panel__content').css({'height': '0', 'padding-top': '0'});
			contentHeight = $(this).parent().next().find('.panel__content__inner').outerHeight() + 20;
			$('.panel__content.show').css({'height': contentHeight, 'padding-top': '20px'});
		} else {
			$(this).addClass('collapsed');
			$(this).parent().next().removeClass('show');
			$(this).parent().next().css({'height': '0', 'padding-top': '0'});
		}
		return false;
	});

});



// WEBPACK FOOTER //
// ./src/js/main.js